import {
  MAC_POLICY_SET_ID,
  WINDOWS_POLICY_SET_ID,
  LINUX_POLICY_SET_ID
} from '@nile/banyan/src/Constants/policySet';
const protocols = () => {
  return [
    {
      label: 'SNMP',
      value: 'SNMP'
    },
    {
      label: 'SSH',
      value: 'SSH'
    }
  ];
};

const ENUMS_DEVICES = {
  PRINTER: 'PRINTER',
  FIREWALL: 'FIREWALL',
  ROUTER: 'ROUTER',
  SWITCH: 'SWITCH'
};

const getDeviceIcon = (name: string) => {
  switch (name) {
    case ENUMS_DEVICES.PRINTER:
      return 'Printer';
    case ENUMS_DEVICES.ROUTER:
      return 'Router';
    case ENUMS_DEVICES.FIREWALL:
      return 'FireWall';
    case ENUMS_DEVICES.SWITCH:
      return 'Switch';
    case 'UPS':
      return 'UPS';
    case 'LOAD_BALANCER':
      return 'LoadBalancer';
    case 'POWER_DISTRIBUTION_UNIT':
      return 'PowerDevice';
    case 'STORAGE':
    case 'NAS':
      return 'Storage';
    case 'WAN_ACCELERATOR':
      return 'Wan';
    case 'WIRELESS_ACCESS_POINT':
      return 'WireLessAccessPoint';
    case 'WIRELESS_LAN_CONTROLLER':
      return 'WirelessLanController';
    case 'VOIP':
      return 'Voip';
    case 'IP_CAMERA':
      return 'IpCamera';
    default:
      return 'UnkownIcon';
  }
};

const DEVICE_TYPES = [
  {
    label: 'Printer',
    value: ENUMS_DEVICES.PRINTER,
    name: ENUMS_DEVICES.PRINTER
  }
];

const SCANNED_ASSET_TYPES = {
  KNOWN: 'KNOWN',
  UNKNOWN: 'UNKNOWN',
  ERROR: 'FAILED',
  IGNORED: 'IGNORED',
  MONITORED: 'MONITORED',
  ICMP_ONLY_ASSETS: 'ICMP_ONLY_ASSETS'
};

const NETWORK_VIEW_IDS = {
  probe: '6001',
  networkScan: '6002',
  discoverAsset: '6003'
};

const SUMMARY_TAB_ID = {
  4: '41',
  5: '51',
  6: '61',
  7: '71',
  8: '9991',
  9: '9991',
  10: '9991',
  11: '9991',
  12: '9991',
  13: '9991',
  14: '9991',
  15: '9991',
  16: '9991',
  17: '9991',
  18: '9991'
};

const DETAIL_TAB_ID = {
  4: '45',
  5: '55',
  6: '65',
  7: '75',
  8: '9995',
  9: '9995',
  10: '9995',
  11: '9995',
  12: '9995',
  13: '9995',
  14: '9995',
  15: '9995',
  16: '9995',
  17: '9995',
  18: '9995'
};

const TIME_SERIES_METRIC_UNIT = {
  Memory: [
    {
      label: 'Bytes',
      value: 'Bytes'
    },
    {
      label: 'KB',
      value: 'KB'
    },
    {
      label: 'MB',
      value: 'MB'
    },
    {
      label: 'GB',
      value: 'GB'
    }
  ],
  DataTransferRate: [
    {
      label: 'Kbps',
      value: 'Kbps'
    },
    {
      label: 'Bps',
      value: 'Bps'
    },
    {
      label: 'Mbps',
      value: 'Mbps'
    },
    {
      label: 'Gbps',
      value: 'Gbps'
    }
  ]
};

const lineColor = {
  color1: '#5959FF',
  color2: '#FF5959',
  color3: '#59C8FF',
  color4: '#59FFB0',
  color5: '#59FFF5'
};
const areaColor = {
  color1: '#8080FF',
  color2: '#FF8080',
  color3: '#80D5FF',
  color4: '#80FFC2',
  color5: '#80FFF7'
};
const CHART_COLOR_CONFIG = {
  '2011': {
    borderColor: '#AC59FF',
    areaColor: '#BF80FF'
  },
  '2010': {
    borderColor: '#FF59FF',
    areaColor: '#FF80FF'
  },
  '2012': {
    borderColor: lineColor['color1'],
    areaColor: areaColor['color1'],
    borderColor1: lineColor['color2'],
    areaColor1: areaColor['color2'],
    borderColor2: lineColor['color3'],
    areaColor2: areaColor['color3'],
    borderColor3: lineColor['color4'],
    areaColor3: areaColor['color4'],
    borderColor4: lineColor['color5'],
    areaColor4: areaColor['color5']
  }
};
const ENDPOINT_MONITERING_METRIC_ID = {
  cpuUsage: '2010',
  memoryUsage: '2011',
  discUsage: '2012'
};
const getDetailsTabId = (data, tabName) => {
  if (data.length > 0) {
    const tab = data[0]?.layout?.find(
      (layout) => layout?.details?.name === tabName
    );
    return tab?.details?.id || null;
  }

  return null;
};

function isEndpointMonitoring(assetClassId: string | number) {
  return (
    assetClassId == MAC_POLICY_SET_ID ||
    assetClassId == WINDOWS_POLICY_SET_ID ||
    assetClassId == LINUX_POLICY_SET_ID
  );
}
function getInterval(dataLength: number, isCurrentUnitTimerEnable: boolean) {
  // needs to check with pm and designer can we use interval or not
  if (dataLength) return 0;

  if (isCurrentUnitTimerEnable) return 0;

  if (dataLength <= 10) return 0;
  if (dataLength <= 50) return 2; // Every 2nd label
  if (dataLength <= 100) return 5; // Every 5th label
  return 10; // Every 10th label for large datasets
}
export {
  protocols,
  SCANNED_ASSET_TYPES,
  NETWORK_VIEW_IDS,
  DEVICE_TYPES,
  ENUMS_DEVICES,
  DETAIL_TAB_ID,
  SUMMARY_TAB_ID,
  getDeviceIcon,
  TIME_SERIES_METRIC_UNIT,
  getDetailsTabId,
  CHART_COLOR_CONFIG,
  ENDPOINT_MONITERING_METRIC_ID,
  isEndpointMonitoring,
  getInterval
};
